import { StackHeaderProps } from '@react-navigation/stack';
import { theme } from 'aimo-ui';
import BuyTicket from 'components/park/hslTicket/BuyTicket';
import HslContextProvider from 'context/HslContextProvider';
import StackHeader from 'navigation/StackHeader';
import React from 'react';
import { useTranslation } from 'react-i18next';
import HslDurationSelection from 'screens/hslTicket/HslDurationSelection';
import HslMandatoryUpdatePhonenumberScreen from 'screens/hslTicket/HslMandatoryUpdatePhonenumberScreen';
import HslSubscriptionSelection from 'screens/hslTicket/HslSubscriptionSelection';
import HslTicketRenderModalContent from 'screens/hslTicket/HslTicketRenderModalContent';
import HslTicketScreen from 'screens/hslTicket/HslTicketScreen';
import HslValidFromSelection from 'screens/hslTicket/HslValidFromSelection';
import HslZoneSelectModalContent from 'screens/hslTicket/HslZoneSelectModalContent';
import ParkAndRideScreen from 'screens/hslTicket/ParkAndRideScreen';
import { useHslStore } from 'stores/hslStore';
import { HslStackParamList } from 'types/navigation';
import { isWeb } from 'utils/deviceUtils';
import { titleTypeText } from 'utils/hslUtils';
import { createStackNavigator } from 'utils/navigationHelpers';

const HslStack = createStackNavigator<HslStackParamList>();
const HeaderComponent: React.FC<StackHeaderProps> = (props) => (
  <StackHeader {...props} />
);

const HslNavigator: React.FC = () => {
  const { t } = useTranslation();
  const hslTicket = useHslStore((state) => state.selectedHslTicket);

  return (
    <HslContextProvider>
      <HslStack.Navigator
        screenOptions={{
          headerTransparent: isWeb,
          headerShown: true,
          cardStyle: {
            backgroundColor: theme.colors.white,
            marginBottom: 50,
          },
          header: HeaderComponent,
        }}>
        <HslStack.Screen
          name="hslTicket"
          component={HslTicketScreen}
          options={{
            title: t('hslTicket.title'),
          }}
        />
        <HslStack.Screen
          name="hslBuyNewTicket"
          component={BuyTicket}
          options={{
            title: t('hslTicket.title'),
          }}
        />
        <HslStack.Screen
          name="hslZoneSelect"
          component={HslZoneSelectModalContent}
          options={{
            title: t('hslTicket.zoneSelectTitle'),
          }}
        />
        <HslStack.Screen
          name="hslDurationSelect"
          component={HslDurationSelection}
          options={{
            title: t('hslTicket.durationScreenTitle'),
          }}
        />
        <HslStack.Screen
          name="hslValidFromSelect"
          component={HslValidFromSelection}
          options={{
            title: t('hslTicket.validityTitle'),
          }}
        />
        <HslStack.Screen
          name="hslSubscriptionSelect"
          component={HslSubscriptionSelection}
          options={{
            title: t('hslTicket.subscriptionTitle'),
          }}
        />
        <HslStack.Screen
          name="hslUpdatePhone"
          component={HslMandatoryUpdatePhonenumberScreen}
          options={{
            title: t('hslTicket.phoneNumber'),
          }}
        />
        <HslStack.Screen
          name="hslTicketRenderView"
          component={HslTicketRenderModalContent}
          options={{
            title: titleTypeText(hslTicket?.ticketType),
          }}
        />
        <HslStack.Screen
          name="parkAndRideTutorial"
          component={ParkAndRideScreen}
          options={{
            title: t('hslTicket.title'),
            headerShown: false,
          }}
        />
      </HslStack.Navigator>
    </HslContextProvider>
  );
};

export default HslNavigator;
